var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center",class:{ 'text-error font-medium': _setup.isExpired }},[(_setup.isExpiringWithin24Hours)?_c('CUIcon',{staticClass:"w-18 h-18 margin-r-1",attrs:{"color":"error","view-box":"0 0 24 24"}},[_vm._v(" access_time ")]):_vm._e(),_vm._v(" "+_vm._s(_setup.expirationText)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }